// Frontend API service for schedule operations
import { getAuthHeaders, handleAuthError } from './authUtils';

// Treat REACT_APP_API_URL as the origin (scheme+host+port). Always prefix paths with /api
const API_ORIGIN = process.env.REACT_APP_API_URL || 'http://localhost:5001';
const API_BASE_URL = `${API_ORIGIN}/api`;

class ScheduleApiService {
  // Get schedule for a specific service
  async getSchedule(serviceName) {
    try {
      
      const headers = getAuthHeaders();
      
      const url = `${API_BASE_URL}/schedule/${serviceName}`;
      
      const response = await fetch(url, {
        headers
      });
      
      
      if (!response.ok) {
        // Check if it's a 401 error and handle it globally
        if (response.status === 401) {
          const error = { response: { status: 401 } };
          if (handleAuthError(error)) {
            throw new Error('Session expired - redirected to login');
          }
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      // scheduleApi: Error details
      throw error;
    }
  }

  // Update schedule for a specific service
  async updateSchedule(serviceName, scheduleData) {
    try {
      const response = await fetch(`${API_BASE_URL}/schedule/${serviceName}`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(scheduleData)
      });
      
      if (!response.ok) {
        // Check if it's a 401 error and handle it globally
        if (response.status === 401) {
          const error = { response: { status: 401 } };
          if (handleAuthError(error)) {
            throw new Error('Session expired - redirected to login');
          }
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  // Remove schedule for a specific service
  async removeSchedule(serviceName) {
    try {
      const response = await fetch(`${API_BASE_URL}/schedule/${serviceName}`, {
        method: 'DELETE',
        headers: getAuthHeaders()
      });
      
      if (!response.ok) {
        // Check if it's a 401 error and handle it globally
        if (response.status === 401) {
          const error = { response: { status: 401 } };
          if (handleAuthError(error)) {
            throw new Error('Session expired - redirected to login');
          }
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  // Enable/disable schedule for a specific service
  async setScheduleEnabled(serviceName, enabled) {
    try {
      const response = await fetch(`${API_BASE_URL}/schedule/${serviceName}/enabled`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ enabled })
      });
      
      if (!response.ok) {
        // Check if it's a 401 error and handle it globally
        if (response.status === 401) {
          const error = { response: { status: 401 } };
          if (handleAuthError(error)) {
            throw new Error('Session expired - redirected to login');
          }
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      throw error;
    }
  }
}

export const scheduleApi = new ScheduleApiService();
